import { Component } from '@angular/core';
import moment from 'moment';
/**
 * Generated class for the CoClockComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'co-clock',
  templateUrl: 'co-clock.html'
})
export class CoClockComponent {

  time: string;
  timeFunction: any;

  constructor() {
  }
  
  ngOnInit() {
    let self = this;
    this.timeFunction = setInterval(function() {
      self.time = moment().format('YYYY-MM-DD HH:mm:ss');
    }, 1000);
  }

  ngOnDestroy() {
    clearInterval(this.timeFunction);
  }

}



// WEBPACK FOOTER //
// ./src/components/co-clock/co-clock.ts